import React, { useState, useEffect } from 'react';
import { Check, Fire, CaretUp, CaretDown } from '@phosphor-icons/react';
import { DYNAMIC_STRETCHES } from '../data/dynamicStretches';

// Compact SVG animations for each stretch
const STRETCH_ANIMS = {
  'squats': (p) => (
    <g>
      <line x1="30" y1="85" x2="30" y2={p?68:52} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .8s'}} />
      <line x1="50" y1="85" x2="50" y2={p?68:52} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .8s'}} />
      <line x1="30" y1={p?68:52} x2="40" y2={p?48:58} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .8s'}} />
      <line x1="50" y1={p?68:52} x2="40" y2={p?48:58} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .8s'}} />
      <line x1="40" y1={p?48:58} x2="40" y2={p?24:34} stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" style={{transition:'all .8s'}} />
      <circle cx="40" cy={p?16:26} r="5" fill="#FF3B30" style={{transition:'all .8s'}} />
    </g>
  ),
  'high-knees': (p) => (
    <g>
      <line x1="45" y1="85" x2="45" y2="65" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="45" y1="65" x2="40" y2="50" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="40" y1="50" x2={p?42:35} y2={p?40:60} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .5s'}} />
      <line x1="40" y1="50" x2="40" y2="28" stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" />
      <circle cx="40" cy="20" r="5" fill="#FF3B30" />
      <line x1="40" y1="32" x2={p?30:50} y2={p?24:38} stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round" style={{transition:'all .5s'}} />
    </g>
  ),
  'leg-swings': (p) => (
    <g>
      <line x1="15" y1="10" x2="15" y2="85" stroke="#525252" strokeWidth="2" />
      <line x1="40" y1="85" x2="40" y2="65" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="40" y1="65" x2="42" y2="50" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="42" y1="50" x2={p?25:60} y2="55" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .7s'}} />
      <line x1="42" y1="50" x2="42" y2="28" stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" />
      <circle cx="42" cy="20" r="5" fill="#FF3B30" />
      <line x1="42" y1="32" x2="15" y2="30" stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round" />
    </g>
  ),
  'lunges': (p) => (
    <g>
      <line x1={p?32:28} y1="85" x2={p?32:28} y2={p?62:72} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .8s'}} />
      <line x1={p?32:28} y1={p?62:72} x2="42" y2={p?42:52} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .8s'}} />
      <line x1="58" y1="85" x2="53" y2={p?72:78} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .8s'}} />
      <line x1="53" y1={p?72:78} x2="42" y2={p?42:52} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .8s'}} />
      <line x1="42" y1={p?42:52} x2="42" y2={p?22:32} stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" style={{transition:'all .8s'}} />
      <circle cx="42" cy={p?15:25} r="5" fill="#FF3B30" style={{transition:'all .8s'}} />
    </g>
  ),
  'plank-walkouts': (p) => (
    <g>
      <line x1="75" y1="55" x2="75" y2="48" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="70" y1="48" x2="50" y2={p?28:40} stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" style={{transition:'all .9s'}} />
      <line x1="50" y1={p?28:40} x2={p?20:45} y2={p?25:22} stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" style={{transition:'all .9s'}} />
      <circle cx={p?16:42} cy={p?20:16} r="5" fill="#FF3B30" style={{transition:'all .9s'}} />
      <line x1={p?22:46} y1={p?30:27} x2={p?15:40} y2="55" stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round" style={{transition:'all .9s'}} />
    </g>
  ),
  'arm-circles': (p) => (
    <g>
      <line x1="40" y1="85" x2="40" y2="65" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="40" y1="65" x2="40" y2="52" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="40" y1="52" x2="40" y2="30" stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" />
      <circle cx="40" cy="22" r="5" fill="#FF3B30" />
      <line x1="40" y1="34" x2={p?20:60} y2={p?20:50} stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round" style={{transition:'all .6s'}} />
      <line x1="40" y1="34" x2={p?60:20} y2={p?50:20} stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round" style={{transition:'all .6s'}} />
      <circle cx="40" cy="35" r="18" fill="none" stroke="#FF3B30" strokeWidth="0.5" opacity="0.3" strokeDasharray="3 3" />
    </g>
  ),
  'standing-toe-taps': (p) => (
    <g>
      <line x1="45" y1="85" x2="45" y2="65" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="45" y1="65" x2="42" y2="50" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="42" y1="50" x2="38" y2={p?38:70} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .6s'}} />
      <line x1="42" y1="50" x2="42" y2="28" stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" />
      <circle cx="42" cy="20" r="5" fill="#FF3B30" />
      <line x1="42" y1="32" x2={p?45:30} y2={p?40:55} stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round" style={{transition:'all .6s'}} />
    </g>
  ),
  'jumping-jacks': (p) => (
    <g>
      <line x1={45-(p?18:0)} y1="85" x2={45-(p?9:0)} y2="65" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .4s'}} />
      <line x1={45+(p?18:0)} y1="85" x2={45+(p?9:0)} y2="65" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .4s'}} />
      <line x1={45-(p?9:0)} y1="65" x2="45" y2="50" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .4s'}} />
      <line x1={45+(p?9:0)} y1="65" x2="45" y2="50" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .4s'}} />
      <line x1="45" y1="50" x2="45" y2="28" stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" />
      <circle cx="45" cy="20" r="5" fill="#FF3B30" />
      <line x1="45" y1="32" x2={45-(p?25:5)} y2={p?15:45} stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round" style={{transition:'all .4s'}} />
      <line x1="45" y1="32" x2={45+(p?25:5)} y2={p?15:45} stroke="#A3A3A3" strokeWidth="2" strokeLinecap="round" style={{transition:'all .4s'}} />
    </g>
  ),
  'butt-kicks': (p) => (
    <g>
      <line x1="45" y1="85" x2="45" y2="65" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="45" y1="65" x2="42" y2="50" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="42" y1="50" x2="40" y2="65" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="40" y1="65" x2={p?38:35} y2={p?42:65} stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" style={{transition:'all .5s'}} />
      <line x1="42" y1="50" x2="42" y2="28" stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" />
      <circle cx="42" cy="20" r="5" fill="#FF3B30" />
    </g>
  ),
  'hip-circles': (p) => (
    <g>
      <line x1="35" y1="85" x2="35" y2="65" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="45" y1="85" x2="45" y2="65" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="35" y1="65" x2="40" y2="52" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="45" y1="65" x2="40" y2="52" stroke="#A3A3A3" strokeWidth="2.5" strokeLinecap="round" />
      <line x1={p?36:44} y1="52" x2="40" y2="30" stroke="#A3A3A3" strokeWidth="3" strokeLinecap="round" style={{transition:'all .7s'}} />
      <circle cx="40" cy="22" r="5" fill="#FF3B30" />
      <circle cx={p?36:44} cy="50" r="7" fill="none" stroke="#FF3B30" strokeWidth="0.5" opacity="0.4" strokeDasharray="2 2" />
    </g>
  ),
};

function MiniStretchAnim({ stretchId }) {
  const [phase, setPhase] = useState(false);
  const render = STRETCH_ANIMS[stretchId];
  useEffect(() => {
    const t = setInterval(() => setPhase(p => !p), 1200);
    return () => clearInterval(t);
  }, []);
  if (!render) return null;
  return (
    <svg viewBox="0 0 80 90" className="w-8 h-8">
      {render(phase)}
    </svg>
  );
}

export default function DynamicWarmUp({ expanded, onToggle, customStretches }) {
  // Use custom stretches if provided, otherwise default
  const stretches = (customStretches && customStretches.length > 0)
    ? customStretches.map((s, i) => ({ id: s.name?.toLowerCase().replace(/\s+/g, '-') || `custom-${i}`, ...s }))
    : DYNAMIC_STRETCHES;

  const [checked, setChecked] = useState({});
  const doneCount = stretches.filter(s => checked[s.id]).length;
  const allDone = doneCount === stretches.length;
  const progress = (doneCount / stretches.length) * 100;

  const toggle = (id) => setChecked(prev => ({ ...prev, [id]: !prev[id] }));

  const checkAll = () => {
    if (allDone) setChecked({});
    else {
      const all = {};
      stretches.forEach(s => { all[s.id] = true; });
      setChecked(all);
    }
  };

  return (
    <div className={`bg-surface border rounded-md overflow-hidden transition-all ${
      allDone ? 'border-success/40' : expanded ? 'border-brand/40' : 'border-border'
    }`} data-testid="dynamic-warmup">
      {/* Collapsed header — always visible */}
      <button
        onClick={onToggle}
        className="w-full p-3 flex items-center gap-2.5 active:bg-elevated/50 transition-colors"
        data-testid="warmup-toggle"
      >
        <div className={`w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0 ${
          allDone ? 'bg-success/15' : 'bg-brand/15'
        }`}>
          <Fire size={20} weight="bold" className={allDone ? 'text-success' : 'text-brand'} />
        </div>
        <div className="text-left flex-1 min-w-0">
          <div className="flex items-center gap-1.5">
            <span className="font-head text-[13px] sm:text-[15px] font-bold uppercase text-white">Dynamic Warm-Up</span>
            {allDone && <Check size={14} weight="bold" className="text-success" />}
          </div>
          <div className="flex items-center gap-2 mt-0.5">
            <span className="text-[10px] text-neutral-500">{doneCount}/{stretches.length} stretches</span>
            <div className="flex-1 h-1 bg-elevated rounded-full overflow-hidden max-w-[80px]">
              <div className="h-full rounded-full transition-all duration-300" style={{
                width: `${progress}%`,
                backgroundColor: allDone ? '#32D74B' : '#FF3B30'
              }} />
            </div>
          </div>
        </div>
        <div className="flex items-center gap-1 ml-1 flex-shrink-0">
          {doneCount > 0 && !allDone && (
            <span className="text-[9px] font-mono text-warning font-bold">{doneCount}/{DYNAMIC_STRETCHES.length}</span>
          )}
          {expanded ? <CaretUp size={14} className="text-neutral-500" /> : <CaretDown size={14} className="text-neutral-500" />}
        </div>
      </button>

      {/* Expanded — stretch checklist */}
      {expanded && (
        <div className="border-t border-border px-3 pb-3 pt-2 space-y-1.5">
          <div className="flex justify-end mb-1">
            <button onClick={checkAll}
              className="text-[9px] font-bold uppercase text-neutral-500 hover:text-white transition-colors px-1.5 py-0.5"
              data-testid="warmup-check-all">
              {allDone ? 'Reset' : 'Check All'}
            </button>
          </div>
          {stretches.map((stretch, idx) => {
            const isDone = checked[stretch.id];
            return (
              <button
                key={stretch.id}
                onClick={() => toggle(stretch.id)}
                className={`w-full flex items-center gap-2 px-2 py-1.5 rounded transition-all active:scale-[0.98] ${
                  isDone ? 'bg-success/5' : 'bg-elevated/30'
                }`}
                data-testid={`warmup-stretch-${stretch.id}`}
              >
                <MiniStretchAnim stretchId={stretch.id} />
                <div className="text-left flex-1 min-w-0">
                  <div className="flex items-center gap-1">
                    <span className="font-mono text-[9px] text-neutral-600">{String(idx + 1).padStart(2, '0')}</span>
                    <span className={`text-xs font-bold uppercase ${isDone ? 'text-success line-through' : 'text-white'}`}>
                      {stretch.name}
                    </span>
                    <span className="text-[9px] text-brand font-bold">{stretch.reps}</span>
                  </div>
                </div>
                <div className={`w-5 h-5 rounded-full border flex items-center justify-center flex-shrink-0 transition-all ${
                  isDone ? 'bg-success border-success' : 'border-neutral-700'
                }`}>
                  {isDone && <Check size={11} weight="bold" className="text-black" />}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
